module.exports = __webpack_public_path__ + "static/media/bwTheme-boy.31c9f798.svg";